var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 122.09,
    height: 122.09,
    viewBox: "0 0 122.09 122.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_265",
    "data-name": "Group 265",
    transform: "translate(-11575.959 2663)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_264",
    "data-name": "Group 264"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_152",
    "data-name": "Group 152",
    transform: "translate(11575.959 -2663)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 61.045,
    cy: 61.045,
    rx: 61.045,
    ry: 61.045,
    transform: "translate(0)",
    fill: "#595a5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_331",
    "data-name": "Path 331",
    d: "M530.991,247.827l23.952-27.842h-5.676l-20.8,24.175-16.611-24.175H492.7l25.119,36.557-25.119,29.2h5.676l21.963-25.529,17.542,25.529H557.04l-26.05-37.911Zm-7.774,9.037-2.545-3.641-20.25-28.965h8.718l16.342,23.376,2.545,3.64L549.27,281.66h-8.719l-17.335-24.795Z",
    transform: "translate(-464.087 -189.444)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.9ea8d2823b303213f0508239e88d05d3.svg";
export { ForwardRef as ReactComponent };